import trans from '../../helpers/trans';
import { EventLogEntityTypeResource } from '../EventLog/EventLog';
import { EventLogCategory } from '../EventLogCategory/EventLogCategory';

export interface NotificationCenterResource {
    uuid: string;
    action: string;
    category: string;
    tags: string[];
    currentUserName: string;
}

export interface NotificationCenterLog {
    uuid: string;
    action: string;
    category: string;
    tags: string[];
    currentUserName: string;
}

// Update this enum from /api/v3/event-logs/categories if needed
export enum NotificationCenterCategory {
    ABSENCE = 'verzuim',
    AGNOSTIC = 'agnostic',
    CUSTOM = 'custom',
    DATA_UPDATE = 'data-update',
    DEPARTMENT = 'afdeling',
    EMAIL = 'email',
    ENTITY = 'entity',
    EXCHANGE = 'exchange',
    FEED_MESSAGE = 'feedbericht',
    LEAVE_OF_ABSENCE = 'verlof',
    PAYROLL_PERIOD = 'payroll-periode',
    PAYROLL_PERIOD_WEEK = 'payroll-periode-week',
    SHIFT = 'dienst',
    SHIFT_EXCHANGE = 'shift-exchange',
    SHIFT_PLANNING = 'dienstplanning',
    SHIFT_PLANNING_REMOVAL = 'dienstplanningremoval',
    TRACKS = 'tracks',
    UNKNOWN = 'unknown',
    USER = 'gebruiker',
    SETTING = 'instelling',
}

// Update this enum from /api/v3/event-logs/actions if needed
export enum NotificationCenterAction {
    AGNOSTIC = 'agnostic',
    CREATED = 'created',
    DELETED = 'deleted',
    GENERATE = 'generate',
    NOTIFICATION = 'notification',
    UNKNOWN = 'unknown',
    UPDATED = 'updated',
}

// Update this enum from /api/v3/event-logs/tags if needed
export enum NotificationCenterActionCategory {
    CONCEPT_SHIFT_CREATED = 'concept-dienst-aangemaakt',
    CONCEPT_SHIFTS_BATCH_PUBLISHED = 'diensten-publiceren',
    EXCHANGE_CREATED = 'open-ruilvoorstel-aangemaakt',
    EXCHANGE_CANCELLED = 'open-ruilvoorstel-geannuleerd',
    EXCHANGE_APPROVED = 'open-ruilvoorstel-goedgekeurd',
    EXCHANGE_DECLINED = 'open-ruilvoorstel-afgewezen',
    EXCHANGE_UPDATED = 'open-ruilvoorstel-gewijzigd',
    PERIOD_LOCKED = 'periode-vergrendeld',
    PERIOD_UNLOCKED = 'periode-ontgrendeld',
    SHIFT_CREATED = 'dienst-aangemaakt',
    SHIFT_DELETED = 'dienst-verwijderd',
    SHIFT_UPDATED = 'dienst-gewijzigd',
    SHIFT_EXCHANGE_CREATED = 'ruildienst-aangemaakt',
    SHIFT_EXCHANGE_CANCELLED = 'ruildienst-geannuleerd',
    SHIFT_EXCHANGE_APPROVED = 'ruildienst-goedgekeurd',
    SHIFT_EXCHANGE_DECLINED = 'ruildienst-afgewezen',
    SHIFT_EXCHANGE_UPDATED = 'ruildienst-gewijzigd',
    SHIFT_PLANNING_CREATED = 'dienstplanning-aangemaakt',
    SHIFT_PLANNING_REGISTERED = 'dienstplanning-aangemeld',
    SHIFT_PLANNING_REGISTRATION_ACCEPTED = 'dienstplanning-aanmelding-geaccepteerd',
    SHIFT_PLANNING_REGISTRATION_DELETED = 'dienstplanning-aanmelding-verwijderd',
    SHIFT_PLANNING_UPDATED = 'dienstplanning-gewijzigd',
    SHIFT_PLANNING_COMMENT_DELETED = 'dienstplanning-comment-verwijderd',
    TRACK_IN_PROGRESS_ENDED_BY_MANAGER = 'lopende-track-afgerond-door-manager',
    USER_LINKED_TO_LOKET = 'gebruiker-gekoppeld-aan-loket',
    USERS_LINKED_TO_LOKET = 'gebruikers-gekoppeld-aan-loket',
    UNKNOWN = 'unknown',
}

export enum NotificationCenterHeaderName {
    X_EVENT = 'x-event',
}

export const CATEGORY_FILTERS: EventLogCategory[] = [
    {
        name: trans('entities.eventLog.category.shift'),
        slug: NotificationCenterCategory.SHIFT,
        type: EventLogEntityTypeResource.shift,
    },
    {
        name: trans('entities.eventLog.category.track'),
        slug: NotificationCenterCategory.TRACKS,
        type: EventLogEntityTypeResource.track,
    },
    {
        name: trans('entities.eventLog.category.user'),
        slug: NotificationCenterCategory.USER,
        type: EventLogEntityTypeResource.user,
    },
    {
        name: trans('entities.eventLog.category.email'),
        slug: NotificationCenterCategory.EMAIL,
        type: EventLogEntityTypeResource.mailV2,
    },
    {
        name: trans('entities.eventLog.category.absence'),
        slug: NotificationCenterCategory.ABSENCE,
        type: EventLogEntityTypeResource.absence,
    },
    {
        name: trans('entities.eventLog.category.leaveOfAbsence'),
        slug: NotificationCenterCategory.LEAVE_OF_ABSENCE,
        type: EventLogEntityTypeResource.leaveOfAbsence,
    },
    {
        name: trans('entities.eventLog.category.department'),
        slug: NotificationCenterCategory.DEPARTMENT,
        type: EventLogEntityTypeResource.department,
    },
    {
        name: trans('entities.eventLog.category.period'),
        slug: NotificationCenterCategory.PAYROLL_PERIOD,
        type: EventLogEntityTypeResource.period,
    },
    {
        name: trans('entities.eventLog.category.periodWeek'),
        slug: NotificationCenterCategory.PAYROLL_PERIOD_WEEK,
        type: EventLogEntityTypeResource.periodWeek,
    },
    {
        name: trans('entities.eventLog.category.settings'),
        slug: NotificationCenterCategory.SETTING,
        type: EventLogEntityTypeResource.setting,
    },
];

export const CONFIG_FILTERS_REQUEST_VALUE_MAP: Partial<Record<NotificationCenterCategory, NotificationCenterCategory[]>> = {
    [NotificationCenterCategory.SHIFT]: [NotificationCenterCategory.SHIFT],
    [NotificationCenterCategory.TRACKS]: [NotificationCenterCategory.TRACKS],
    [NotificationCenterCategory.USER]: [NotificationCenterCategory.USER],
    [NotificationCenterCategory.ABSENCE]: [NotificationCenterCategory.ABSENCE],
    [NotificationCenterCategory.EMAIL]: [NotificationCenterCategory.EMAIL],
    [NotificationCenterCategory.LEAVE_OF_ABSENCE]: [NotificationCenterCategory.LEAVE_OF_ABSENCE],
    [NotificationCenterCategory.DEPARTMENT]: [NotificationCenterCategory.DEPARTMENT],
    [NotificationCenterCategory.PAYROLL_PERIOD]: [NotificationCenterCategory.PAYROLL_PERIOD],
    [NotificationCenterCategory.PAYROLL_PERIOD_WEEK]: [NotificationCenterCategory.PAYROLL_PERIOD_WEEK],
    [NotificationCenterCategory.SETTING]: [NotificationCenterCategory.SETTING],
};
